import { render, staticRenderFns } from "./GreenGoodDesignAwardFrame.vue?vue&type=template&id=03bbd9f6"
import script from "./GreenGoodDesignAwardFrame.vue?vue&type=script&lang=js"
export * from "./GreenGoodDesignAwardFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03bbd9f6')) {
      api.createRecord('03bbd9f6', component.options)
    } else {
      api.reload('03bbd9f6', component.options)
    }
    module.hot.accept("./GreenGoodDesignAwardFrame.vue?vue&type=template&id=03bbd9f6", function () {
      api.rerender('03bbd9f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/green-good-design-award/components/GreenGoodDesignAwardFrame.vue"
export default component.exports